export default "__VITE_ASSET__f1560b16__"